import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';


const styles = css`
  position: relative;
  z-index: 2;
  padding: 10px 30px;
  @media(min-width: 992px) {
    padding: 0 30px;
  }
  .Disclosures_copy {
    color: #FFFFFF;
    font-size: 14px;
    text-align: center;
    line-height: 17px;
    @media(min-width: 992px) {
      font-size: 12px;
    }
  }
`;

function ContactDisclosures({ page }) {
  return (
    <div className={styles}>
      <p className="Disclosures_copy">{get(page, 'form_disclosure')}</p>
    </div>
  );
}

ContactDisclosures.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'disclosures',
  },
)(ContactDisclosures);



// WEBPACK FOOTER //
// ./src/components/ContactDisclosures.js